
import {Component, Prop, Vue} from 'vue-property-decorator'
import {RawLocation} from 'vue-router'

@Component
export default class ButtonCommon extends Vue {

  @Prop() readonly href?: RawLocation
  @Prop({ default: false }) readonly symbolic?: boolean

  private click(): void {
    this.$emit('click');
  }

  render(createElement: any) {
    const tag = this.href ? 'router-link' : 'button';
    return createElement(tag, {
      class: [
        'button-common strong', {
          symbolic: this.symbolic
        }
      ],
      attrs: {
        to: this.href
      },
      on: {
        click: this.click
      },
    }, this.$slots.default);
  }

}
